import { Injectable } from '@angular/core';
import { CreateAccountExperimentApplicationEvent } from '~shared/modules/application-event/models';
import { OPTIMIZE_ACTIVATION_EVENT } from '~shared/constants/optimize-activation-event.constant';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { APP_CART_ROUTE, APP_PRODUCT_ROUTE, APP_USER_IDAM_REGISTER_ROUTE, CHECKOUT_ROUTE, } from '~shared/constants';
import { filter, take } from 'rxjs/operators';
import { IdentityService } from '~core/modules/identity/services/identity.service';

@Injectable({
  providedIn: 'root'
})
export class OptimizeActivationEventService {

  constructor(private applicationEventService: ApplicationEventService, private identityService: IdentityService) { }

  triggerActivationEvent(pageUrl) {
    if(pageUrl.includes(APP_PRODUCT_ROUTE)) {
      this.createSellerNameChangeMetroMakroExperimentEvent();
    }
  }

  private createSellerNameChangeMetroMakroExperimentEvent() {
    this.applicationEventService.publish(
      new CreateAccountExperimentApplicationEvent(
        OPTIMIZE_ACTIVATION_EVENT.sellerNameChangeMetroMakro, '')
    );
  }
}
